import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, document.title, window.location.pathname);
        const user = await loginWithToken(data.token);
        navigate(user.role ? "/leaderboard" : "/role");
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="grain min-h-screen flex flex-col items-center justify-center gap-4">
      <Crown className="gold-text animate-pulse" size={36} strokeWidth={1.5} />
      <p className="text-zinc-400 text-sm" data-testid="auth-callback-status">
        {error || "Preparing your crown…"}
      </p>
    </div>
  );
};

export default AuthCallback;
